import { isCouple } from 'common/utils/hasPartner';
import { SIGNATURE_TYPE } from 'common/utils/signature/signatureTypes';

const COMPLETED = 'completed';

const getSignerType = (rip, signer) => (
    rip.clientAndPartnerSignatureDate && rip.clientAndPartnerSignatureDate[signer]
        ? rip.clientAndPartnerSignatureDate[signer].type
        : undefined
);

export const hasSignedElectronicallyClient = (rip) => (
    SIGNATURE_TYPE.ELECTRONIC_DONE === getSignerType(rip, 'client') && COMPLETED === rip.universignTransactionState
);

export const hasSignedElectronicallyPartner = (rip) => (
    SIGNATURE_TYPE.ELECTRONIC_DONE === getSignerType(rip, 'partner') && COMPLETED === rip.universignTransactionState
);

export const hasSignedManuallyClient = (rip) => (
    !!rip.signature
);

export const hasSignedManuallyPartner = (rip) => (
    !!rip.partnerSignature
);

export const hasSignedClient = (rip) => (
    hasSignedElectronicallyClient(rip) || hasSignedManuallyClient(rip)
);

export const hasSignedPartner = (rip) => (
    hasSignedElectronicallyPartner(rip) || hasSignedManuallyPartner(rip)
);

export const hasSignedClientAndPartner = (rip) => (
    hasSignedClient(rip) && hasSignedPartner(rip)
);

export const separationRegime = (rip) => (
    'separationAsToProperty' === rip.communityRegime || 'separationOfEstate' === rip.communityRegime
);

export const hasSignedElectronically = (rip) => (
    !!rip.universignTransaction && COMPLETED === rip.universignTransactionState
);

export const hasSignedManually = (rip) => (
    !!(rip.signature && (!isCouple(rip.familySituation) || rip.partnerSignature))
);

const hasSigned = (rip) => (
    hasSignedElectronically(rip) || hasSignedManually(rip)
);

export default hasSigned;
